
export function setWithExpiry(key, value, ttl) {
    const now = new Date()

    const item = {
        value: value,
        expiry: now.getTime() + ttl
    }

    localStorage.setItem(key, JSON.stringify(item))
}

export function getWithExpiry(key) {
    const serializedItem = localStorage.getItem(key)

    if (!serializedItem) {
        return null
    }

    const item = JSON.parse(serializedItem)
    const now = new Date()

    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

// MPI-415: sessionStorage helpers backing the persistent (per browser tab/session) multi-company
// selection. Unlike setWithExpiry/getWithExpiry (localStorage, time-based expiry, shared across
// tabs), these use sessionStorage so the selection naturally clears when the browser session ends
// and stays isolated per tab/session.
export function setSessionItem(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
        // ignore storage errors (e.g. disabled storage/private browsing quota)
    }
}

export function getSessionItem(key) {
    try {
        const serializedItem = sessionStorage.getItem(key)

        if (!serializedItem) {
            return null
        }

        return JSON.parse(serializedItem)
    } catch (e) {
        return null
    }
}

export function removeSessionItem(key) {
    try {
        sessionStorage.removeItem(key)
    } catch (e) {
        // ignore storage errors
    }
}

// MPI-415: localStorage helpers (no expiry) backing data that should stay in sync across
// browser tabs for the same user (e.g. the multi-company selection), unlike setSessionItem/
// getSessionItem which are isolated per tab.
export function setLocalItem(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
        // ignore storage errors (e.g. disabled storage/private browsing quota)
    }
}

export function getLocalItem(key) {
    try {
        const serializedItem = localStorage.getItem(key)

        if (!serializedItem) {
            return null
        }

        return JSON.parse(serializedItem)
    } catch (e) {
        return null
    }
}

export function removeLocalItem(key) {
    try {
        localStorage.removeItem(key)
    } catch (e) {
        // ignore storage errors
    }
}
